import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { UserAuthProvider } from './context/UserAuthContext';
import { SiteContentProvider } from './context/SiteContentContext';
import { AnalyticsProvider } from './context/AnalyticsContext';
import { DesignProvider } from './context/DesignContext';
import { Toaster } from './components/ui/sonner';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import ProtectedUserRoute from './components/ProtectedUserRoute';
import CookieConsent from './components/common/CookieConsent';
import Home from './pages/Home';
import Programs from './pages/Programs';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Team from './pages/Team';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AnalyticsDashboard from './pages/admin/AnalyticsDashboard';
import TeamManagement from './pages/admin/TeamManagement';
import UserLogin from './pages/auth/UserLogin';
import UserRegister from './pages/auth/UserRegister';
import Dashboard from './pages/dashboard/Dashboard';
import SchedulePage from './pages/schedule/SchedulePage';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <SiteContentProvider>
        <DesignProvider>
          <AnalyticsProvider>
            <AdminAuthProvider>
              <UserAuthProvider>
                <BrowserRouter>
                  <ScrollToTop />
                  <AnalyticsTracker />
                  <div className="App">
                    <Routes>
                      {/* Admin Routes - No Layout */}
                      <Route path="/admin/login" element={<AdminLogin />} />
                      <Route
                        path="/admin/dashboard"
                        element={
                          <ProtectedAdminRoute>
                            <AdminDashboard />
                          </ProtectedAdminRoute>
                        }
                      />
                      <Route
                        path="/admin/analytics"
                        element={
                          <ProtectedAdminRoute>
                            <AnalyticsDashboard />
                          </ProtectedAdminRoute>
                        }
                      />
                      <Route
                        path="/admin/team"
                        element={
                          <ProtectedAdminRoute>
                            <TeamManagement />
                          </ProtectedAdminRoute>
                        }
                      />
                      <Route
                        path="/admin/*"
                        element={
                          <ProtectedAdminRoute>
                            <AdminDashboard />
                          </ProtectedAdminRoute>
                        }
                      />

                      {/* User Auth Routes - No Layout */}
                      <Route path="/user-login" element={<UserLogin />} />
                      <Route path="/register" element={<UserRegister />} />
                      
                      {/* Protected User Routes - No Layout */}
                      <Route
                        path="/dashboard"
                        element={
                          <ProtectedUserRoute>
                            <Dashboard />
                          </ProtectedUserRoute>
                        }
                      />
                      <Route path="/schedule" element={<SchedulePage />} />

                      {/* Public Routes - With Layout */}
                      <Route
                        path="/*"
                        element={
                          <Layout>
                            <Routes>
                              <Route path="/" element={<Home />} />
                              <Route path="/programs" element={<Programs />} />
                              <Route path="/pricing" element={<Pricing />} />
                              <Route path="/about" element={<About />} />
                              <Route path="/contact" element={<Contact />} />
                              <Route path="/team" element={<Team />} />
                              <Route path="/login" element={<Login />} />
                            </Routes>
                          </Layout>
                        }
                      />
                    </Routes>
                    <Toaster position="bottom-left" richColors />
                    <CookieConsent />
                  </div>
                </BrowserRouter>
              </UserAuthProvider>
            </AdminAuthProvider>
          </AnalyticsProvider>
        </DesignProvider>
      </SiteContentProvider>
    </LanguageProvider>
  );
}

export default App;
